import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Header3 from "../../components/header/Header3";
import Footer2 from "../../components/footer2";
import Gotop from "../../components/gotop";
import { Link, NavLink } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa"; // Import icons
import { useParams } from "react-router-dom";
import Breadcrumbuser from "../../components/breadcrumbuser";
import { useContext } from "react";
import { AuthContext } from "../../AuthContext";
import "../../assets/FakeTable.css";

function AppointmentInvoice() {
    const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);

  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
   const [categoriesnew2, setCategoriesnew2] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
     fetchCategoriesnew2();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort"); // Adjust the URL if needed
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    }
  };

  const fetchCategoriesnew = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort"); // Adjust the URL if needed
      setCategoriesnew(response.data);
    } catch (error) {
      console.error("Error fetching horoscope categories:", error);
    }
  };

  const fetchCategoriesnew1 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort"); // Adjust the URL if needed
      setCategoriesnew1(response.data);
    } catch (error) {
      console.error("Error fetching astro categories:", error);
    }
  };

   const fetchCategoriesnew2 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort"); // Adjust the URL if needed
      setCategoriesnew2(response.data);
    } catch (error) {
      console.error("Error course categories:", error);
    }
  };

const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
   const { logout } = useContext(AuthContext);

  const { bookingId } = useParams();
  const invoiceRef = useRef();

  const [appointment, setAppointment] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Fetch appointment invoice data
    axios.get(
  `https://adhigyanam-e92bf1bbbdb1.herokuapp.com/appointments/${bookingId}`
)
      .then(res => setAppointment(res.data))
      .catch(err => console.error(err));
  }, [bookingId]);

  useEffect(() => {
    const uid = localStorage.getItem("userId");
    if (!uid) return;

    axios
      .get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/getuserbyid/${uid}`)
      .then(res => setUser(res.data))
      .catch(err => console.error(err));
  }, []);

  

const formatDate = (value) => {
  if (!value) return "-";

  // MySQL DATETIME: YYYY-MM-DD HH:MM:SS
  // Also supports: YYYY-MM-DDTHH:MM:SS
  if (typeof value === "string") {
    const match = value.match(
      /^(\d{4})-(\d{2})-(\d{2})/
    );

    if (match) {
      const [, year, month, day] = match;
      return `${day}-${month}-${year}`;
    }
  }

  // Handles JavaScript Date objects returned by mysql2
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const day = String(value.getDate()).padStart(2, "0");
    const month = String(value.getMonth() + 1).padStart(2, "0");
    const year = value.getFullYear();

    return `${day}-${month}-${year}`;
  }

  return "-";
};

const formatTime = (value) => {
  if (!value) return "-";

  // MySQL DATETIME: YYYY-MM-DD HH:MM:SS
  // Also supports: YYYY-MM-DDTHH:MM:SS
  if (typeof value === "string") {
    const match = value.match(
      /[ T](\d{2}):(\d{2})/
    );

    if (match) {
      const [, hour, minute] = match;
      return `${hour}:${minute}`;
    }
  }

  // Handles JavaScript Date objects returned by mysql2
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const hour = String(value.getHours()).padStart(2, "0");
    const minute = String(value.getMinutes()).padStart(2, "0");

    return `${hour}:${minute}`;
  }

  return "-";
};

  if (!appointment || !user) {
    return <p style={{ textAlign: "center" }}>Please Wait! Loading invoice...</p>;
  }

  return (
    <>
      <Helmet>
                <title>Download Invoice - Adhigyanam | Sauntesthyam LLP</title>
              </Helmet>
              <div className="menu-mobile-popup">
            <div className="modal-menu__backdrop" onClick={handleMobile}></div>
            <div className="widget-filter">
              <div className="mobile-header">
                <div id="logo" className="logo">
                  <Link to="/home">
                    <img className="site-logo" src={logo} alt="Image" />
                  </Link>
                </div>
                <Link className="title-button-group" onClick={handleMobile}>
                  <i className="icon-close"></i>
                </Link>
              </div>
    
              <Tabs className="tf-tab">
            

            <div className="content-tab">
              <TabPanel className="header-ct-center menu-moblie animation-tab">
                <div className="nav-wrap">
                  <nav className="main-nav mobile">
                    <ul id="menu-primary-menu" className="menu">
                    <li className="menu-item ">
                        <Link
                          to="/home"
                          className="iteam-menu"
                          
                        >
                          Home
                        </Link>
                      </li>
                      {/* <li className="menu-item ">
                        <Link
                          to="/about"
                          className="iteam-menu"
                          
                        >
                          About Us
                        </Link>
                      </li> */}

                   

                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("services");
                          }}
                        >
                          eConsultation
                        </Link>
                        <Collapse isOpened={toggle.key === "services"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "services" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew1.length > 0 ? (
          categoriesnew1.map((categorynew1, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/category-details/${categorynew1.Id}`}>{categorynew1.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                     
                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("courses");
                          }}
                        >
                          eLearning
                        </Link>
                        <Collapse isOpened={toggle.key === "courses"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "courses" ? "block" : "none"
                              }`,
                            }}
                          >
                           {categoriesnew2.length > 0 ? (
          categoriesnew2.map((categoriesnew2, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/course-category-details/${categoriesnew2.Id}`}>{categoriesnew2.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}
                            
                          </ul>
                        </Collapse>
                      </li>
                    <li className="menu-item ">
                        <Link
                          to="/epooja"
                          className="iteam-menu"
                          
                        >
                          ePooja
                        </Link>
                      </li>
                     
                         <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("horoscope");
                          }}
                        >
                         Horoscope
                        </Link>
                        <Collapse isOpened={toggle.key === "horoscope"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "horoscope" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew.length > 0 ? (
          categoriesnew.map((categorynew, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/horoscopes/${categorynew.Id}`}>{categorynew.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                       <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("blog");
                          }}
                        >
                          Blog
                        </Link>
                        <Collapse isOpened={toggle.key === "blog"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "blog" ? "block" : "none"
                              }`,
                            }}
                          >

 {categories.length > 0 ? (
          categories.map((categories, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/blog-category-details/${categories.Id}`}>{categories.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                      <li className="menu-item ">
                        <Link
                          to="/support"
                          className="iteam-menu"
                          
                        >
                         FAQ & Support
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </TabPanel>

           
            </div>
          </Tabs>
              <div className="header-customize-item button" style={{padding: "0px 0px",
        background:"none",
        backgroundColor:"#14a077",
        borderRadius: "4px",
        fontWeight: "700",
        fontSize: "16px",
        lineHeight: "21px",
        color: "white",
        borderColor: "transparent",
        textTransform: "capitalize"}}>
                <Link to="/userdashboard" style={{color: "#ffffff"}}>Dashboard</Link>
              </div>
               
              
    
               <div className="mobile-footer">
                <div className="icon-infor d-flex aln-center">
                  <div className="icon">
                    <span className="icon-call-calling">
                      <span className="path1"></span>
                      <span className="path2"></span>
                      <span className="path3"></span>
                      <span className="path4"></span>
                    </span>
                  </div>
                  <div className="content">
                    <p>Need help? 24/7</p>
                    <h6>
                       <Link to={`tel:918960708425`}>+91-8960708425</Link>
                    </h6>
                  </div>
                </div>
                <p><b>Corporate Address</b>: Sauntesthyam LLP, Munshi Puliya, Indira Nagar, Lucknow, Uttar Pradesh - 226016</p>
                <p style={{marginTop:"15px"}}><b>Write To Us On</b>: <Link to={`mailto:sauntesthyam@gmail.com`} style={{textDecoration:"underline"}}>sauntesthyam@gmail.com</Link>, <Link to={`mailto:info@adhigyanam.com`}  style={{textDecoration:"underline"}}>info@adhigyanam.com</Link></p>
                <div className="wd-social d-flex aln-center" style={{marginTop:"15px"}}>
          <ul className="list-social d-flex aln-center">
                                         <li><Link to="https://www.facebook.com/Adhigyanam"><i className="icon-facebook"></i></Link></li>
                                         <li><Link to="https://www.instagram.com/the_vedic_astro"><i className="icon-instagram1"></i></Link></li>
                                         <li><Link to="https://x.com/adhigyanam"><i className="icon-twitter"></i></Link></li>
                                     </ul>
        </div>
              </div>
              <div >
                          <button onClick={logout} className="header-customize-item button" style={{padding: "12px 20px",
        background:"none",
        backgroundColor:"white",
        borderRadius: "4px",
        fontWeight: "700",
        fontSize: "16px",
        lineHeight: "21px",
        color: "black",
        borderColor: "red",
        textTransform: "capitalize"}}>Logout</button>
                        </div>
            </div>
          </div>
      <Header3 clname="act1" handleMobile={handleMobile} />
      <Breadcrumbuser title="Download Invoice" />

      <section style={{ padding: "20px 0" }}>
       <div
  id="invoice"
  ref={invoiceRef}
  style={{
    maxWidth: 700,
    margin: "auto",
    padding: 20,
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: 8
  }}
>
<div className="col-lg-12 col-md-12" style={{textAlign:"center"}}>
        <img src={require ('../../assets/siteimages/logo.jpeg')} style={{width:"185px", height:"auto", margin:"auto", padding:"auto", paddingTop:"15px", paddingBottom:"0px"}} alt="images" />
        </div>
          <h6 style={{ marginBottom: '10px', textAlign: 'center', borderBottom: '2px solid #000', paddingBottom: '10px', fontSize:"18px" }}>
            Sauntesthyam LLP
            <br/><span style={{fontSize:"13px", fontWeight:"normal"}}>Munshi Puliya, Indira Nagar, Lucknow, Uttar Pradesh - 226016</span>
          </h6>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <b>Billed To</b><br />
              {user.Named}<br />
              {user.Email}<br />
              {user.Cno}
            </div>

            <div>
              <b>Invoice Details</b><br />
              Booking ID: #{appointment.Id}<br />
              Booked On: {formatDate(appointment.BookingDate)}
            </div>
          </div>

          <table style={{ width: "100%", marginTop: 20, borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#f3f4f6" }}>
                <th style={{ padding: 10, border: "1px solid #ddd" }}>eConsultation</th>
                <th style={{ padding: 10, border: "1px solid #ddd" }}>Astrologer</th>
                <th style={{ padding: 10, border: "1px solid #ddd" }}>Plan Price</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ padding: 10, border: "1px solid #ddd" }}>
                  {appointment.Category}
                </td>
                <td style={{ padding: 10, border: "1px solid #ddd" }}>
                  {appointment.AstrologerName}
                </td>
                <td style={{ padding: 10, border: "1px solid #ddd" }}>
                  ₹{Number(appointment.TotalPrice).toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>
         <div style={{ marginTop: 24 }}>
  {/* Section Title */}
  <h4
    style={{
      fontSize: 14,
      fontWeight: 700,
      marginBottom: 10,
      paddingBottom: 0,
      color: "#111827",
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    Session Details
  </h4>

  <table
    style={{
      width: "100%",
      borderCollapse: "collapse",
      fontSize: 13,
      color: "#111827"
    }}
  >
    <tbody>
     <tr>
        <td
          style={{
            padding: "10px 12px",
            background: "#f9fafb",
            border: "1px solid #e5e7eb",
            fontWeight: 600
          }}
        >
          Plan
        </td>
        <td
          style={{
            padding: "10px 12px",
            border: "1px solid #e5e7eb"
          }}
        >
          {appointment.CustomerName}
        </td>
      </tr>
      <tr>
        <td
          style={{
            padding: "10px 12px",
            width: "35%",
            background: "#f9fafb",
            border: "1px solid #e5e7eb",
            fontWeight: 600
          }}
        >
          Session Date
        </td>
        <td
          style={{
            padding: "10px 12px",
            border: "1px solid #e5e7eb"
          }}
        >
          {formatDate(appointment.start_datetime)}
        </td>
      </tr>

      <tr>
        <td
          style={{
            padding: "10px 12px",
            background: "#f9fafb",
            border: "1px solid #e5e7eb",
            fontWeight: 600
          }}
        >
          Start Time
        </td>
        <td
          style={{
            padding: "10px 12px",
            border: "1px solid #e5e7eb"
          }}
        >
          {formatTime(appointment.start_datetime)} IST
        </td>
      </tr>

      <tr>
        <td
          style={{
            padding: "10px 12px",
            background: "#f9fafb",
            border: "1px solid #e5e7eb",
            fontWeight: 600
          }}
        >
          Session Duration
        </td>
        <td
          style={{
            padding: "10px 12px",
            border: "1px solid #e5e7eb"
          }}
        >
          {appointment.user_time} minutes
        </td>
      </tr>

      

      {appointment.TopicNames && (
        <tr>
          <td
            style={{
              padding: "10px 12px",
              background: "#f9fafb",
              border: "1px solid #e5e7eb",
              fontWeight: 600
            }}
          >
            Topics Covered
          </td>
          <td
            style={{
              padding: "10px 12px",
              border: "1px solid #e5e7eb"
            }}
          >
            {appointment.TopicNames}
          </td>
        </tr>
      )}
    </tbody>
  </table>
</div>

        <div style={{ textAlign: "right", marginTop: 20 }}>
        <h6 style={{ fontSize: 16, marginTop: 10 }}>
    Plan Total:
    <span style={{ marginLeft: 6 }}>
      ₹{Number(appointment.TotalPrice).toFixed(2)} INR
    </span>
  </h6>
  <h6 style={{ fontSize: 16, marginTop: 10 }}>
    Amount Paid:
    <span style={{ marginLeft: 6 }}>
      ₹{Number(appointment.PaidAmount).toFixed(2)} INR
    </span>
  </h6>
</div>
            <div style={{ marginTop: 15, fontSize: 13 }}>
  <h4 style={{ marginBottom: 10, fontSize: 14 }}>
    Terms & Conditions
  </h4>
  <ul style={{
    paddingLeft: 20,
    lineHeight: 1.6,
    listStyleType: "disc"
  }}>
    <li>The consultation is valid only for the booked date and time.</li>
    <li>Rescheduling is subject to astrologer availability.</li>
    <li>No refunds are applicable once the session is confirmed.</li>
    <li>In case of technical issues, support must be contacted immediately.</li>
    <li>The session duration is fixed as per the selected plan.</li>
    <li>All consultations are confidential and non-transferable.</li>
    <li>Prices are inclusive of all applicable taxes.</li>
  </ul>
</div>
        </div>

        <div style={{ textAlign: "center", marginTop: 20 }}>
          <button
            onClick={() => window.print()}
            style={{
              padding: "12px 24px",
              background: "#14a077",
              color: "#fff",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
              fontWeight: 700
            }}
          >
            Download / Print
          </button>
        </div>
      </section>
      <div
                  className="floating-buttons"
                  style={{
                    position: "fixed",
                    bottom: "20px",
                    left: "20px",
                    zIndex: "1000",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {/* Call Button */}
                  <a
                    href={`tel:+918960708425`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#007BFF",
                      borderRadius: "50%",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                      color: "white",
                      fontSize: "28px",
                    }}
                  >
                    <FaPhoneAlt />
                  </a>
                
                  {/* WhatsApp Button */}
                  <a
                    href={`https://wa.me/918960708425`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#25D366",
                      borderRadius: "50%",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                      color: "white",
                      fontSize: "28px",
                    }}
                  >
                    <FaWhatsapp />
                  </a>
                </div>
      <Footer2 />
      <Gotop />

      <style>
        {`
          @media print {
  body {
    background: white;
  }

  button,
  .floating-buttons,
  header,
  footer {
    display: none !important;
  }

  #invoice {
    margin: 0;
    box-shadow: none;
    border: none;
  }
}
          
        `}
      </style>
    </>
  );
}

export default AppointmentInvoice;